var map = {
	"./logo-alphabet.svg": 1775,
	"./logo-amazon-2.svg": 1776,
	"./logo-amazon.svg": 1348,
	"./logo-azercell.svg": 1584,
	"./logo-bank-of-america.svg": 729,
	"./logo-barclays.svg": 730,
	"./logo-bbc.svg": 1777,
	"./logo-bnp-paribas.svg": 731,
	"./logo-booking.svg": 672,
	"./logo-citibank.svg": 618,
	"./logo-coca-cola.svg": 1778,
	"./logo-deloitte.svg": 1779,
	"./logo-experian.svg": 1780,
	"./logo-facebook.svg": 1781,
	"./logo-g.svg": 1782,
	"./logo-goldman-sachs.svg": 732,
	"./logo-google.svg": 1783,
	"./logo-h.svg": 1784,
	"./logo-henkel.svg": 1785,
	"./logo-hsbc.svg": 1786,
	"./logo-ikea.svg": 1787,
	"./logo-infineon.svg": 1788,
	"./logo-instagram.svg": 1789,
	"./logo-jp-morgan.svg": 733,
	"./logo-jti.svg": 1630,
	"./logo-linkedin.svg": 1790,
	"./logo-meta.svg": 1791,
	"./logo-morgan-stanley.svg": 1792,
	"./logo-netflix.svg": 1793,
	"./logo-oracle.svg": 1349,
	"./logo-paypal.svg": 619,
	"./logo-pwc-new.svg": 1794,
	"./logo-pwc.svg": 1795,
	"./logo-spotify.svg": 1796,
	"./logo-tesla.svg": 620,
	"./logo-visa.svg": 1350,
	"./logo-walmart.svg": 528,
	"./logo-youtube.svg": 1797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1774;